/* eslint-disable react/no-unescaped-entities */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import Session from './Session.js';
import jwt_decode from 'jwt-decode';
import { Link } from 'react-router-dom';
import { AsteriskIcon, BackIcon, Footer, Loading, SettingsIcon } from '../components/PageElements.js';
import { IoSchoolOutline, IoPeopleCircleOutline } from 'react-icons/io5/index.js';
import { IoIosPeople } from 'react-icons/io/index.js';
import { TiMessages } from 'react-icons/ti/index.js';
import { FaPhotoVideo, FaSms, FaUserEdit, FaWpforms } from 'react-icons/fa/index.js';
import { GoCalendar } from 'react-icons/go/index.js';
import { MdEditDocument, MdOutlineNoAccounts, MdOutlineSettings, MdOutlineStickyNote2, MdSettings } from 'react-icons/md/index.js';
import { BsPersonBadge, BsCalculator, BsPatchQuestionFill, BsPeopleFill, BsArrowUpCircle, BsListStars, BsMegaphoneFill } from 'react-icons/bs/index.js';
import { GiTakeMyMoney, GiIdCard } from 'react-icons/gi/index.js';
import { AiOutlineBarChart, AiOutlineFileDone, AiOutlineIdcard } from 'react-icons/ai/index.js';
import Redirect from './Redirect.js';
import UserContext from './UserContext.js';
import { FaBook } from 'react-icons/fa6/index.js';
import { ImExit } from 'react-icons/im/index.js';
import { useMutation } from '@apollo/client';
import { QUIT_SCHOOL } from '../Graphql/School.js';
import { APIResponse } from './Helpers.js';


export const isLoggedIn = () => {
  const token = Session.secureValue('x-access-token');

  if (!token) {
    return false;
  }
  try {
    const decoded = jwt_decode(token);

    const isExpired = decoded.exp <= Math.floor(Date.now() / 1000);
    if (isExpired || !decoded.id) {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
};


export const Menu = () => {
  const myContext = React.useContext(UserContext);
  const school = myContext.school;
  const pupilCount = myContext.objects.pupils?.length;
  const messageCount = myContext.objects.pupils?.filter((p) => p.parentReplied).length;
  const [tab, setTab] = useState(parseInt(Session.value('menuTab')) || 1);

  const accessToken = Session.secureValue('x-access-token');
  const myRoles = jwt_decode(accessToken).roles['' + school.id];
  const isOwner = myRoles == 'OWNER';
  // const nav = useNavigate();

  const changeTab = (x) => {
    setTab(x);
    Session.setValue('menuTab', '' + x);
  };

  // Pre-compute all role checks at the top level to avoid Rules of Hooks violations
  // authorize is NOT called here — we inline the role check logic once
  const _roles = myRoles || [];
  const canManageClassroom = isOwner || _roles.includes('manage_classroom');
  const canAttendancePupil = isOwner || _roles.includes('attendance_pupil');
  const canCreatePupils = isOwner || _roles.includes('create_pupils');
  const canMessages = isOwner || _roles.includes('messages');
  const canDeleteMessages = isOwner || _roles.includes('delete_messages');
  const canReports = isOwner || _roles.includes('reports');
  const canSettings = isOwner || _roles.includes('settings');
  const canKiosk = isOwner || _roles.includes('kiosk');
  const canPromotion = isOwner || _roles.includes('promotion');
  const canAccounts = isOwner || _roles.includes('accounts');
  const canDebtors = isOwner || _roles.includes('debtors');
  const canProspects = isOwner || _roles.includes('prospects');
  const canManageStaff = isOwner || _roles.includes('manage_staff');
  const canEmployees = isOwner || _roles.includes('employees');
  const canFixedAsset = isOwner || _roles.includes('fixedasset');
  const canAttendanceAdmin = isOwner || _roles.includes('attendance_admin');
  const canInventoryCategory = isOwner || _roles.includes('inventory_category');
  const canInventoryLocation = isOwner || _roles.includes('inventory_location');
  const canInventoryItem = isOwner || _roles.includes('inventory_item');
  const canInventoryReceiveStock = isOwner || _roles.includes('inventory_receive_stock');
  const canInventoryHistory = isOwner || _roles.includes('inventory_history');
  const canInventoryReports = isOwner || _roles.includes('inventory_reports');

  // QUIT_SCHOOL

  let [quitNow, { loading }] = useMutation(QUIT_SCHOOL, {
    onCompleted: () => {
      Session.alert('You have been removed from ' + school.name);
      Redirect('/dashboard');
    },
    onError: error => {
      Session.alert('Unable to disconnect you from school.');
      APIResponse(error);
      Session.showAlert();
    }
  });



  return (
    <div className='w3-animate-bottom'>

      <div className="row p-0 m-0 justify-content-center">

        {tab === 1 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/classroom" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <IoSchoolOutline size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Classroom
                    <span className={'d-md-none w3-small w3-right'}>&nbsp;{school?.classrooms?.length || 0}</span>
                    <span className={'d-none d-md-inline'}>&nbsp;({school?.classrooms?.length || 0})</span>
                  </h4>
                  <div className='w3-opacity text-md-center'>Manage classrooms & Activities</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 1 && (canAttendancePupil || canCreatePupils) &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/pupils" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any2 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <IoPeopleCircleOutline size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Pupils
                    <span className={'d-md-none w3-small w3-right'}>&nbsp;{pupilCount || 0}</span>
                    <span className={'d-none d-md-inline'}>&nbsp;({pupilCount || 0})</span>
                  </h4>
                  <div className='w3-opacity text-md-center'>Manage pupils & Parents</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 1 && canCreatePupils &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/parentinvite" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any12 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <IoIosPeople size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Invite Parents <AsteriskIcon />
                  </h4>
                  <div className='w3-opacity text-md-center'>Invite parents in bulk</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 1 && (canMessages || canDeleteMessages) &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/messages" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any4 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <TiMessages size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Messages
                    <span className={'d-md-none w3-small w3-right'}>&nbsp;{messageCount || 0}</span>
                    <span className={'d-none d-md-inline'}>&nbsp;({messageCount || 0})</span></h4>
                  <div className='w3-opacity text-md-center'>School/parent communication</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 1 && (canAttendancePupil || canCreatePupils) &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/studentgroups" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any5 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsPeopleFill size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Student Groups</h4>
                  <div className='w3-opacity text-md-center'>Organize students into groups</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 1 &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/newperformancereport" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-black text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <AiOutlineFileDone size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Student Performance</h4>
                  <div className='w3-opacity text-md-center'>Weekly/Monthly Performance</div>

                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 1 &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/weeklyconduct" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-black text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsPatchQuestionFill size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Weekly Conduct Report</h4>
                  <div className='w3-opacity text-md-center'>Create weekly report (E/S/N/U)</div>

                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 && canKiosk &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/syllabuxvideos" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any9 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <FaPhotoVideo size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Learning Aids</h4>
                  <div className='w3-opacity text-md-center'>Videos and Games</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/bookclub" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any3 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <FaBook size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>BookShelf</h4>
                  <div className='w3-opacity text-md-center'>Non-Academic Books</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 && canKiosk &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/kiosk" className='btn w-100 text-start w3-card-2 w3-hover-opacity my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-amber text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <AiOutlineIdcard size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Smart Checkin/Out</h4>
                  <div className='w3-opacity text-md-center'>Smart Checkin/Out</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 && canKiosk &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/newquestionbank" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsPatchQuestionFill size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>C.B.T</h4>
                  <div className='w3-opacity text-md-center'>Digital Tests & Assessments</div>
                </div>
              </div>
            </Link>
          </div>
        }




        {tab === 1 && canKiosk &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/lessonplan" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any2 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdOutlineStickyNote2 size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Lesson Plans</h4>
                  <div className='w3-opacity text-md-center'>Manage Lesson Plans</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 && canPromotion &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/promotion" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-theme2-d3 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsArrowUpCircle size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Promotion</h4>
                  <div className='w3-opacity text-md-center'>Promote Pupils</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/birthdays" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any8 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GoCalendar size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Dates & Events</h4>
                  <div className='w3-opacity text-md-center'>Birthdays & Calendar</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 1 && canKiosk &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/virtualclass" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-purple text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdOutlineStickyNote2 size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Virtual Classroom</h4>
                  <div className='w3-opacity text-md-center'>Remote Learning</div>
                </div>
              </div>
            </Link>
          </div>
        }





        {tab === 2 && canAccounts &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/accounts/accountingsettings" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-black text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdSettings size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Account Setup</h4>
                  <div className='w3-opacity text-md-center'>Setup Accounts</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 2 && canAccounts &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/accounts" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-brown text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsCalculator size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Accounting</h4>
                  <div className='w3-opacity text-md-center'>Finance & Accounts</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 2 && canAccounts &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/accounts/payroll" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-indigo text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiTakeMyMoney size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Payroll</h4>
                  <div className='w3-opacity text-md-center'>Employee salaries</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 2 && school.json?.billingType != 'Manual' && canAccounts &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/bills" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any15 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <FaWpforms size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Bills</h4>
                  <div className='w3-opacity text-md-center'>Manage Pupil Bills</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 2 && school.json?.billingType == 'Manual' && canAccounts &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/manualbill" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any15 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <FaWpforms size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Manual Bills</h4>
                  <div className='w3-opacity text-md-center'>Manage Pupil Bills</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 2 && school.json?.billingType != 'Manual' && canDebtors &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/debtors" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-orange text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsListStars size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Debtor&apos;s List</h4>
                  <div className='w3-opacity text-md-center'>List of indebted students</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 2 && school.json?.billingType == 'Manual' && canDebtors &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/manualdebtors" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-orange text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsListStars size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Debtor&apos;s List</h4>
                  <div className='w3-opacity text-md-center'>List of indebted students</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && canProspects &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/prospectivepupils" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any2 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <IoPeopleCircleOutline size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Prospects</h4>
                  <div className='w3-opacity text-md-center'>Follow-up prospective pupils.</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && canProspects &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/sms" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any2 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <FaSms size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>SMS Messages</h4>
                  <div className='w3-opacity text-md-center'>Pending & Sent Messages.</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 3 && canManageStaff &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/staff" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any3 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <BsPersonBadge size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Invited Staff</h4>
                  <div className='w3-opacity text-md-center'>Add/remove app staff</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && canEmployees &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/employee" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any5 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <IoIosPeople size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Employee / HR</h4>
                  <div className='w3-opacity text-md-center'>Employee management</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && canFixedAsset &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/fixedasset" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any11 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiTakeMyMoney size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Fixed Asset Tracker</h4>
                  <div className='w3-opacity text-md-center'>Furniture, equipment etc</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && canAttendanceAdmin &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/editattendance" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-purple text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <FaUserEdit size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Cards & Attendance</h4>
                  <div className='w3-opacity text-md-center'>Manage Cards/Attendance</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && (canAttendancePupil || canCreatePupils) &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/inactivepupils" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-black text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdOutlineNoAccounts size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Inactive Pupils</h4>
                  <div className='w3-opacity text-md-center'>Pupils no longer in school</div>
                </div>
              </div>
            </Link>
          </div>
        }
        {/* 
        {tab === 3 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/newreportcard" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiIdCard size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Create Report Cards</h4>
                  <div className='w3-opacity text-md-center'>Create Report Cards</div>
                </div>
              </div>
            </Link>
          </div>
        } */}
        {tab === 3 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/reportcardv3" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiIdCard size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Create Report Cards V3</h4>
                  <div className='w3-opacity text-md-center'>Create Report Cards V3</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 3 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/reportcardv4" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiIdCard size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Create Report Cards V4</h4>
                  <div className='w3-opacity text-md-center'>Create Report Cards V4</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/managetemplates" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiIdCard size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Manage Templates</h4>
                  <div className='w3-opacity text-md-center'>Manage report card templates</div>
                </div>
              </div>
            </Link>
          </div>
        }
        {tab === 3 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/uploadreportcards" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any1 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <GiIdCard size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Upload Report Card</h4>
                  <div className='w3-opacity text-md-center'>Upload report cards</div>
                </div>
              </div>
            </Link>
          </div>
        }
        {tab === 3 && canManageClassroom &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/documents" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any11 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdEditDocument size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Documents</h4>
                  <div className='w3-opacity text-md-center'>Upload/View Documents</div>
                </div>
              </div>
            </Link>
          </div>
        }


        {tab === 3 && (
          canInventoryCategory ||
          canInventoryLocation ||
          canInventoryItem ||
          canInventoryReceiveStock ||
          canInventoryHistory ||
          canInventoryReports
        ) &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/inventory" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any11 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdEditDocument size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Inventory</h4>
                  <div className='w3-opacity text-md-center'>Inventory Management</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 3 && canReports &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/school/reports" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any8 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <AiOutlineBarChart size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Reports</h4>
                  <div className='w3-opacity text-md-center'>General Reports</div>
                </div>
              </div>
            </Link>
          </div>
        }

        {tab === 3 && canSettings &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            <Link to="/schoolsettings" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any13 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <MdOutlineSettings size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>School Settings</h4>
                  <div className='w3-opacity text-md-center'>School settings</div>
                </div>
              </div>
            </Link>
          </div>
        }

        <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
          <Link to="/school/news" className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
            <div className='row'>
              <div className='col-2 col-md-12 text-center w3-center'>
                <span className='badge d-inline-block w3-circle w3-orange text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                  <BsMegaphoneFill size={70} />
                </span>
              </div>
              <div className='col-10 col-md-12 w3-display-container'>
                <h4 className='w3-large my-0 text-md-center mt-md-2'>Newsfeed</h4>
                <div className='w3-opacity text-md-center'>App Updates and Information</div>
              </div>
            </div>
          </Link>
        </div>


        {!isOwner &&
          <div className=' col-md-6 col-lg-4 w3-animate-right px-0 mx-0 px-md-1'>
            {loading ? <Loading _fullPage={false} /> : <button onClick={() => {
              const sure = confirm('Are you sure you want to quit this school?\nYou will need an invite code to join again as a staff.');
              if (sure) {
                const code = Math.floor(1000 + Math.random() * 8000);
                const response = prompt('To disconnect from this school, type ' + code, '');
                if (response == code) {
                  quitNow({
                    variables: {
                      schoolID: school.id,
                      type: 'STAFF'
                    }
                  })
                }
              }
            }} className='btn w-100 text-start w3-card-2 w3-hover-opacity w3-round-large my-1 syllabux-white py-3'>
              <div className='row'>
                <div className='col-2 col-md-12 text-center w3-center'>
                  <span className='badge d-inline-block w3-circle w3-any13 text-center d-flex align-items-center justify-content-center mx-auto' style={{ height: 40, width: 40 }}>
                    <ImExit size={70} />
                  </span>
                </div>
                <div className='col-10 col-md-12 w3-display-container'>
                  <h4 className='w3-large my-0 text-md-center mt-md-2'>Quit School</h4>
                  <div className='w3-opacity text-md-center'>Disconnect from {school.name}</div>
                </div>
              </div>
            </button>
            }
          </div>
        }


        <div className='p-5'></div>

      </div>
      <Footer>
        <div className='row'>
          <div className='col-3 m-0 p-0'>
            <Link to='#' onClick={() => changeTab(1)} className={((!tab || tab === 1) ? 'w3-theme2-d2' : '') + ' w3-btn w3-border-0 w-100 pb-3'}><BsPeopleFill className='ft-icon' /><br />Pupils</Link>
          </div>
          <div className='col-3 m-0 p-0'>
            <Link to='#' onClick={() => changeTab(2)} className={(tab === 2 ? 'w3-theme2-d2' : '') + ' w3-btn w-100 pb-3'}><BsCalculator className='ft-icon' /><br />Accounts</Link>
          </div>
          <div className='col-3 m-0 p-0'>
            <Link to='#' onClick={() => changeTab(3)} className={(tab === 3 ? 'w3-theme2-d2' : '') + ' w3-btn w-100 pb-3'}><SettingsIcon className='ft-icon' /><br />Admin</Link>
          </div>
          <div className='col-3 m-0 p-0'>
            <Link to='/dashboard' className='w3-btn w-100 pb-3'><BackIcon className='ft-icon' /><br />Dashboard</Link>
          </div>
        </div>
      </Footer>
    </div >
  );
};

export const authorize = (role, redirect = false, myContext = null) => {
  if (!myContext) {
    try { myContext = React.useContext(UserContext); } catch (e) { return false; }
  }
  if (!myContext?.school?.id) return false;
  const schoolID = myContext.school.id;
  const accessToken = Session.secureValue('x-access-token');
  if (!accessToken) return false;
  let myRoles;
  try { myRoles = jwt_decode(accessToken).roles['' + schoolID]; } catch (e) { return false; }

  if (myRoles == 'OWNER') return true;
  if (redirect && !myRoles?.includes(role)) {
    Session.alert('You do not have sufficient priviledge to access the requested page.');
    Redirect('/school');
  }
  return myRoles?.includes(role);
};


export const onPageLoad = (myContext) => {
  const pathname = window.location.pathname;
  const classrooms = (myContext.school.classrooms?.length > 0);
  const pupils = (myContext.objects.pupils?.length > 0);
  const calendar = true;


  if (pathname.endsWith('/pupils') && (!classrooms || !calendar)) {
    Session.alert('Create classrooms before creating pupils.');
    return false;
  }

  if (pathname.endsWith('/resulttemplate') && (!classrooms)) {
    Session.alert('Create classrooms before creating pupils.');
    return false;
  }

  if (pathname.endsWith('/createreportcards') && (!classrooms)) {
    Session.alert('Create classrooms before creating report cards.');
    return false;
  }
  if (pathname.endsWith('/editattendance') && (!classrooms || !pupils)) {
    Session.alert('Create classrooms before creating report cards.');
    return false;
  }

  if (pathname.endsWith('/messages') && (!pupils)) {
    Session.alert('Pls create pupils before sending or reading messages.');
    return false;
  }

  if (pathname.endsWith('/kiosk') && (!pupils)) {
    Session.alert('Pls create pupils before attempting to check them in or out.');
    return false;
  }


  if (pathname.endsWith('/newquestionbank') && (!classrooms)) {
    Session.alert('Pls create classrooms before accessing question bank.');
    return false;
  }

  if (pathname.endsWith('/managequestionbank') && (!classrooms || !pupils)) {
    Session.alert('Pls create classrooms and pupils before accessing CBT.');
    return false;
  }

  if (pathname.endsWith('/assignedquestions') && (!classrooms || !pupils)) {
    Session.alert('Pls create classrooms and pupils before accessing CBT.');
    return false;
  }

  if (pathname.endsWith('/lessonplan') && (!classrooms)) {
    Session.alert('Pls create classrooms before accessing lesson plans.');
    return false;
  }
  return true;
};


export const getMyCampus = () => {
  return Session.object('campus');
};


export const planAllows = (task) => {
  const myContext = React.useContext(UserContext);
  const school = myContext.school;
  const plan = school.plan;
  let isAllowed = true;
  const allowedPlans = [];
  myContext.objects.CONFIG.plans.forEach((element) => {
    if (element.name == plan && element.restrict.includes(task)) {
      isAllowed = false;
    } else if (!element.restrict.includes(task)) {
      allowedPlans.push(element.name);
    }
  });
  return { isAllowed, allowedPlans };
};
